import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sucess-error-dialog',
  standalone: false,
  templateUrl: './sucess-error-dialog.html',
  styleUrl: './sucess-error-dialog.less'
})
export class SucessErrorDialog implements OnInit{

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private matDialogRef:MatDialogRef<SucessErrorDialog>,
  ){

  }

  ngOnInit(): void {
    
  }

  moveToCatalog(){
    this.matDialogRef.close('close');
  }

  addAnotherEntry(){
    this.matDialogRef.close('anotherEntry');
  }
}
